import React from 'react';
import styled from 'styled-components';
import { bool, func } from 'prop-types';

import categoryProps from 'TMPropTypes/categoryProps';
import { CategoryLabels } from 'TMComponents/Typography/styles';

const Wrapper = styled.div`
    ${CategoryLabels}
    align-items: center;
    background: ${({ isActive, theme }) =>
        isActive
            ? theme.colorSystem.primary[4]
            : theme.colorSystem.primary[3]};
    color: ${({ isActive, theme }) =>
        isActive
            ? theme.colorSystem.primary[3]
            : theme.colorSystem.primary[1]};
    border-radius: 30px;
    border: ${({ isActive }) => (isActive ? 'none' : '3px solid #E3E7F0')};
    display: inline-flex;
    justify-content: center;
    margin-right: 10px;
    padding: 0 32px;

    ${({ large, allowToggle }) =>
        (large || allowToggle) &&
        `
        font-size: 0.875rem;
        font-weight: 700;
        line-height: 1.5rem;
        letter-spacing: -0.35px;
        padding: 8px 24px;
        height: auto;
    `};

    ${(props) =>
        props.allowToggle &&
        `
        cursor: pointer;
        margin-bottom: 10px;
        margin-top: 10px;
        transition: all 0.25s;
    `};
`;

const CategoryPill = ({ name, large, allowToggle, isActive, onClick }) => (
    <Wrapper
        large={large}
        allowToggle={allowToggle}
        isActive={isActive}
        onClick={onClick}>
        {name}
    </Wrapper>
);

CategoryPill.propTypes = {
    large: bool,
    allowToggle: bool,
    isActive: bool,
    onClick: func,
    ...categoryProps
};

CategoryPill.defaultProps = {
    large: false,
    allowToggle: false,
    isActive: true,
    onClick: undefined
};

export default CategoryPill;
